import React from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router-dom';
import routes from '../../common/constants/RouteConstants';
import LoginForm from './LoginForm';
import ActivateAccountForm from './ActivateAccountForm';
import ResetPasswordForm from './ResetPasswordForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import LockedAccountCard from './LockedAccountCard';
import ChangePasswordForm from './ChangePasswordForm';
// import TwoFactorAuthInputForm from './TwoFactorAuthInputForm';
// import TwoFactorAuthBackupCodeInputForm from './TwoFactorAuthBackupCodeInputForm';
import TwoFactorAuthViaAppInputForm from './TwoFactorAuthViaAppInputForm';
import SSOLoginForm from './SSOLoginForm';
import SelectWorkspaceForm from './SelectWorkspaceForm';

function LoginRouter() {
  const location = useLocation();

  return (
    <Switch>
      <Route
        path={routes.loginManagement.activateAccount}
        component={ActivateAccountForm}
      />
      <Route
        path={routes.loginManagement.resetPassword}
        component={ResetPasswordForm}
      />
      <Route
        path={routes.loginManagement.forgotPassword}
        component={ForgotPasswordForm}
      />
      <Route
        path={routes.loginManagement.accountLocked}
        component={LockedAccountCard}
      />
      <Route
        path={routes.loginManagement.changePassword}
        component={ChangePasswordForm}
      />
      <Route
        path={routes.loginManagement.mfa}
        component={TwoFactorAuthViaAppInputForm}
      />
      <Route
        path={routes.loginManagement.selectWorkspace}
        component={SelectWorkspaceForm}
      />
      <Route path={routes.loginManagement.ssoLogin} component={SSOLoginForm} />
      <Route exact path="/login" component={LoginForm} />
      <Redirect
        from="*"
        to={{
          pathname: '/login',
          state: location.state,
        }}
      />
    </Switch>
  );
}

export default LoginRouter;
